import React, { useState, useRef, useEffect, useCallback } from "react";
// import { FaEdit, FaSave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import { useLoader } from '../context/LoaderProvider.jsx';
const initialRowsConfig = [
    { key: "Admin Name", value: "", document: null, isUpload: true, isEditing: false, status: "Pending" },
    // { key: "Company Name", value: "", isEditing: false, status: "Pending" },
    { key: "Phone No", value: "", isEditing: false, status: "Pending" },
    { key: "Email ID", value: "", isEditing: false, status: "Pending" },
    {
        key: "Address",
        value: { doorNo: "", street: "", city: "", state: "", pincode: "", landmark: "", location: "", statecode: "" },
        isEditing: false, status: "Pending"
    },
    { key: "AADHAR CARD NO", value: "", document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
    { key: "PAN CARD NO", value: "", document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
    { key: "Trade License", value: { startDate: "", endDate: "" }, document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },

    // { key: "Labour License", value: { startDate: "", endDate: "" }, document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
    { key: "GST No.", value: "", isEditing: false, status: "Not Verified" },
    { key: "CIN Number", value: "", isEditing: false, status: "Pending" },
    {
        key: "Bank Details",
        value: { holderName: "", accountNumber: "", branchName: "", ifscCode: "", passbookFile: null, passbookServerFileName: "" },
        isEditing: false, status: "Pending"
    },

];


const Registration = ({ onNext }) => {
    const [vendorDetails, setVendorDetails] = useState(null);
    const [rows, setRows] = useState(initialRowsConfig.map(r => r.key === "Remarks" ? { ...r, isEditing: false } : r));
    const fileInputRefs = useRef([]);
    const nestedFileInputRefs = useRef({});
    const [userId, setUserId] = useState(null); // This will hold the potentially problematic userId
    const [loading, setLoading] = useState(false);
    const [vendorId, setVendorId] = useState(null);
    const [currentVendorId, setCurrentVendorId] = useState(null);
    const navigate = useNavigate();
    const { showLoader, hideLoader } = useLoader();

    const getRowConfigForKey = (key) => initialRowsConfig.find(r => r.key === key) || { value: {} };

    const getServerDocPlaceholder = useCallback((rowKey, details) => {
        if (!details) return null;
        switch (rowKey) {
            case "AADHAR CARD NO":
                return details.aadharImage ? { name: "Aadhaar Document (on server)", url: details.aadharImage } : null;
            case "PAN CARD NO":
                return details.panImage ? { name: "PAN Document (on server)", url: details.panImage } : null;
            case "Admin Name":
                return details.adminImage ? { name: "Admin Image (on server)", url: details.adminImage } : null;

            case "Bank Details":
                return details.passbook ? { name: "Passbook (on server)", url: details.passbook } : null;
            case "Trade License":
                return details.tradeLicenseDocument ? { name: "Trade License (on server)", url: details.tradeLicenseDocument } : null;
            default:
                return null;
        }
    }, []);



    const getStatusForDocumentField = useCallback((key, details) => {
        const initialStatus = getRowConfigForKey(key)?.status || "Pending";
        if (!details) return initialStatus;
        let hasDocOnServer = false; let isVerifiedByApi = false;
        switch (key) {

            case "AADHAR CARD NO": hasDocOnServer = !!details.aadharPhotoFront; isVerifiedByApi = !!details.aadharNumberStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.aadharNumber ? "Provided" : "Not Verified");
            case "PAN CARD NO": hasDocOnServer = !!details.panCard; isVerifiedByApi = !!details.panCardStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.panCardNumber ? "Provided" : "Not Verified");
            case "Register Documents": hasDocOnServer = !!details.registeredDocumentsFront; isVerifiedByApi = !!details.registeredDocumentsStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer ? "Provided" : "Pending");
            case "Trade License": hasDocOnServer = !!details.tradeLicense; isVerifiedByApi = !!details.tradeLicenseStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.tradeLicenseStartDate ? "Provided" : "Not Verified");
            case "FSC License": hasDocOnServer = !!details.fssaiLicense; isVerifiedByApi = !!details.fssaiLicenseStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.fssaiStartDate ? "Provided" : "Not Verified");
            case "Labour License": hasDocOnServer = !!details.labourLicense; isVerifiedByApi = !!details.labourLicenseStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.labourStartDate ? "Provided" : "Not Verified");
            case "Passbook": hasDocOnServer = !!details.passbook; return hasDocOnServer ? "Provided" : "Not Uploaded";
            default: return initialStatus;
        }
    }, []);

    const mapAndSetRowsFromVendorDetails = useCallback((details) => {
        if (!details) {
            setRows(initialRowsConfig.map(r => ({ ...r, isEditing: r.key === "Remarks" ? false : r.isEditing, document: r.isUpload ? null : undefined })));
            return;
        }
        const updatedRows = initialRowsConfig.map(rowConfig => {
            const newRow = { ...rowConfig, document: rowConfig.isUpload ? null : undefined, isEditing: rowConfig.key === "Remarks" ? false : false };
            let valueFromApi;
            let statusFromApi = getRowConfigForKey(rowConfig.key)?.status || "Pending";

            switch (rowConfig.key) {
                case "Admin Name":
                    valueFromApi = details.ownerName;
                    if (details.hasOwnProperty('ownerNameStatus'))
                        statusFromApi = details.ownerNameStatus ? "Verified" : (details.ownerName ? "Provided" : "Pending");
                    newRow.document = getServerDocPlaceholder(rowConfig.key, details);
                    statusFromApi = getStatusForDocumentField(rowConfig.key, details);
                    newRow.adminImage = details.adminImage || "http://10.10.20.9:9000/foodandbevarages/super_admin_profile/1761195810501_network-connection-background-abstract-style_23-2148875738.avif?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=minioadmin%2F20251023%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20251023T064719Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=a28abc594a1114c6045f40f526641d837d6924da2f24cda4cc7ad0cb5809b2ac";
                    break;

                case "Company Name":
                    valueFromApi = details.companyName;
                    if (details.hasOwnProperty('registeredNameStatus'))
                        statusFromApi = details.registeredNameStatus ? "Verified" : (details.registeredName ? "Provided" : "Pending");
                    break;

                case "Business Plan":
                    valueFromApi = details.businessPlan;
                    if (details.hasOwnProperty('businessPlanStatus'))
                        statusFromApi = details.businessPlanStatus ? "Verified" : (details.businessPlan ? "Provided" : "Pending");
                    break;

                case "Type":
                    valueFromApi = details.type;
                    if (details.hasOwnProperty('typeStatus'))
                        statusFromApi = details.typeStatus ? "Verified" : (details.type ? "Provided" : "Pending");
                    break;

                case "Vendor Type":
                    valueFromApi = details.vendorType;
                    if (details.vendorType) statusFromApi = "Provided";
                    break;

                case "Business Vertical":
                    valueFromApi = details.businessVertical;
                    if (details.businessVertical) statusFromApi = "Provided";
                    break;

                case "Website":
                    valueFromApi = details.websiteName;
                    if (details.hasOwnProperty('websiteNameStatus'))
                        statusFromApi = details.websiteNameStatus ? "Verified" : (details.websiteName ? "Provided" : "Pending");
                    break;

                case "Phone No":
                    valueFromApi = details.phoneNumber;
                    if (details.hasOwnProperty('mobileNumberStatus'))
                        statusFromApi = details.mobileNumberStatus ? "Verified" : (details.phoneNumber ? "Provided" : "Pending");
                    break;

                case "Email ID":
                    valueFromApi = details.email;
                    if (details.hasOwnProperty('emailStatus'))
                        statusFromApi = details.emailStatus ? "Verified" : (details.email ? "Provided" : "Pending");
                    break;

                case "Address":
                    const defaultAddress = getRowConfigForKey("Address").value;
                    valueFromApi = {
                        ...defaultAddress,
                        doorNo: details.doorNumber,
                        street: details.addressLine,
                        city: details.city,
                        state: details.state,
                        pincode: details.pincode !== undefined && details.pincode !== null ? String(details.pincode) : "",
                        landmark: details.landMark,
                        location: details.location,
                        statecode: details.stateCode
                    };
                    statusFromApi = Object.values(valueFromApi).some(v => !!v) ? "Provided" : "Pending";
                    break;

                case "AADHAR CARD NO":
                    valueFromApi = details.aadharNumber;
                    newRow.document = getServerDocPlaceholder(rowConfig.key, details);
                    statusFromApi = getStatusForDocumentField(rowConfig.key, details);
                    newRow.aadharImage = details.aadharImage || "http://10.10.20.9:9000/foodandbevarages/super_admin_profile/1761195810501_network-connection-background-abstract-style_23-2148875738.avif?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=minioadmin%2F20251023%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20251023T064719Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=a28abc594a1114c6045f40f526641d837d6924da2f24cda4cc7ad0cb5809b2ac";
                    break;

                case "PAN CARD NO":
                    valueFromApi = details.panNumber;
                    newRow.document = getServerDocPlaceholder(rowConfig.key, details);
                    statusFromApi = getStatusForDocumentField(rowConfig.key, details);
                    newRow.panImage = details.panImage || "http://10.10.20.9:9000/foodandbevarages/super_admin_profile/1761195810501_network-connection-background-abstract-style_23-2148875738.avif?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=minioadmin%2F20251023%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20251023T064719Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=a28abc594a1114c6045f40f526641d837d6924da2f24cda4cc7ad0cb5809b2ac";
                    break;

                case "Trade License":
                    valueFromApi = { startDate: details.tradeStartDate || "", endDate: details.tradeEndDate || "" };
                    newRow.document = getServerDocPlaceholder(rowConfig.key, details);
                    statusFromApi = getStatusForDocumentField(rowConfig.key, details);
                    break;

                case "FSC License":
                    valueFromApi = { startDate: details.fssaiStartDate || "", endDate: details.fssaiEndDate || "" };
                    newRow.document = getServerDocPlaceholder(rowConfig.key, details);
                    statusFromApi = getStatusForDocumentField(rowConfig.key, details);
                    break;

                case "Labour License":
                    valueFromApi = { startDate: details.labourStartDate || "", endDate: details.labourEndDate || "" };
                    newRow.document = getServerDocPlaceholder(rowConfig.key, details);
                    statusFromApi = getStatusForDocumentField(rowConfig.key, details);
                    break;

                case "GST No.":
                    valueFromApi = details.gstNumber;
                    if (details.hasOwnProperty('gstNumberStatus'))
                        statusFromApi = details.gstNumberStatus ? "Verified" : (details.gstNumber ? "Provided" : "Not Verified");
                    else if (details.gstNumber)
                        statusFromApi = "Provided";
                    else
                        statusFromApi = "Not Verified";
                    break;

                case "Register Documents":
                    newRow.document = getServerDocPlaceholder(rowConfig.key, details);
                    statusFromApi = getStatusForDocumentField(rowConfig.key, details);
                    break;

                case "CIN Number":
                    valueFromApi = details.cinNumber;
                    if (details.hasOwnProperty('emailStatus'))
                        statusFromApi = details.emailStatus ? "Verified" : (details.email ? "Provided" : "Pending");
                    break;

                case "Bank Details":
                    const defaultBankDetails = getRowConfigForKey("Bank Details").value;
                    valueFromApi = {
                        ...defaultBankDetails,
                        holderName: details.holderName,
                        accountNumber: details.accountNumber,
                        branchName: details.branchName,
                        ifscCode: details.ifscCode,
                        passbookFile: null
                    };
                    if (details.passbook) {
                        valueFromApi.passbookServerFileName = "Passbook (on server)";
                    } else {
                        valueFromApi.passbookServerFileName = "";
                    }
                    const hasTextData = valueFromApi.holderName || valueFromApi.accountNumber || valueFromApi.branchName || valueFromApi.ifscCode;
                    statusFromApi = hasTextData || valueFromApi.passbookServerFileName ? "Provided" : "Pending";
                    break;

                case "Remarks":
                    valueFromApi = details.remarks;
                    statusFromApi = details.remarks ? "Provided" : undefined;
                    newRow.isEditing = false;
                    break;

                default:
                    valueFromApi = rowConfig.value;
            }
            newRow.value = valueFromApi !== undefined && valueFromApi !== null ? valueFromApi : rowConfig.value;
            newRow.status = statusFromApi;
            return newRow;
        });
        setRows(updatedRows);
    }, [getStatusForDocumentField, getServerDocPlaceholder]);


    const getDocumentFile = (rowKey) => {
        const row = rows.find(r => r.key === rowKey);
        if (!row) return null;
        if (row.isUpload) return row.document || null;
        if (row.key === "Bank Details") return row.value?.passbookFile || null;
        return null;
    };




    const fetchSuperAdminProfile = useCallback(async () => {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        setLoading(true);
        try {
            showLoader();
            const res = await fetch(
                `https://backend.maamaas.com/food/api/super-admin-profile/1`, // Fixed vendorId 1
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            );

            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            const data = await res.json();
            setVendorDetails(data);
            mapAndSetRowsFromVendorDetails(data);

            // ✅ Always edit vendorId 1
            setCurrentVendorId(1);
        } catch (err) {
            console.error("Failed to fetch profile:", err);
            // alert("Failed to load Super Admin profile");
        } finally {
            setLoading(false);
            hideLoader();
        }
    }, [mapAndSetRowsFromVendorDetails]);




    // Fire once on mount
    useEffect(() => {
        fetchSuperAdminProfile();
    }, [fetchSuperAdminProfile]);

    /* ---------- UI ---------- */
    if (loading) return <p>Loading…</p>;




    const handleEdit = (index) => {
        if (rows[index].key === "Remarks") return;
        setRows(prevRows => prevRows.map((r, i) => ({ ...r, isEditing: i === index })));
    };
    const handleSave = (index) => setRows(prevRows => prevRows.map((r, i) => i === index ? { ...r, isEditing: false } : r));

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];
        if (!file) return;
        setRows(prev => prev.map((r, i) => i === index ? { ...r, document: file } : r));
    };






    const handleNestedFileChange = (e, rowIndex, fileKey) => {
        const file = e.target.files[0];
        if (!file) return;

        setRows(prevRows => {
            const updatedRows = [...prevRows];
            const row = { ...updatedRows[rowIndex] };

            if (!row.value || typeof row.value !== "object") {
                row.value = {};
            }
            row.value[fileKey] = file; // store the File object here
            updatedRows[rowIndex] = row;
            return updatedRows;
        });
    };


    // ✅ Complete PUT Update Code (multipart with files)
    const handleUpdateAll = async () => {
        const token = localStorage.getItem("authToken");
        if (!token) return alert("Token missing. Please log in again.");
        if (!currentVendorId) return alert("Vendor ID missing. Cannot update.");

        const formData = new FormData();

        // 🧠 Get nested address & bank data safely
        const addressValue = getValue("Address") || {};
        const bankDetailsValue = getValue("Bank Details") || {};

        // 🧾 Construct JSON profile data
        const profileData = {
            ownerName: getValue("Admin Name") || null,
            phoneNumber: getValue("Phone No") || null,
            email: getValue("Email ID") || null,
            doorNumber: addressValue.doorNo || null,
            addressLine: addressValue.street || null,
            city: addressValue.city || null,
            state: addressValue.state || null,
            stateCode: addressValue.statecode || null,
            pincode: addressValue.pincode ? parseInt(addressValue.pincode, 10) : null,
            landMark: addressValue.landmark || null,
            location: addressValue.location || null,
            aadharNumber: getValue("AADHAR CARD NO") || null,
            panNumber: getValue("PAN CARD NO") || null,
            tradeStartDate: getValue("Trade License")?.startDate || null,
            tradeEndDate: getValue("Trade License")?.endDate || null,
            gstNumber: getValue("GST No.") || null,
            holderName: bankDetailsValue.holderName || null,
            accountNumber: bankDetailsValue.accountNumber || null,
            branchName: bankDetailsValue.branchName || null,
            ifscCode: bankDetailsValue.ifscCode || null,
            remarks: getValue("Remarks") || null,
            cinNumber: getValue("CIN Number") || null,
        };

        // ✅ Add JSON as Blob
        formData.append(
            "profileData",
            new Blob([JSON.stringify(profileData)], { type: "application/json" })
        );

        // ✅ CORRECTED: Map UI keys to backend file fields
        const fileKeyMap = {
            "Admin Name": "adminImage",
            "AADHAR CARD NO": "aadharImage",
            "PAN CARD NO": "panImage",
            "Trade License": "tradeLicenseDocument", // ✅ FIXED: Changed from "tradeLicense" to "tradeLicenseDocument"
            "FSC License": "fssaiLicense",
            "Labour License": "labourLicense",
            "Bank Details": "passbook",
        };

        // ✅ Attach file(s)
        rows.forEach((row) => {
            if (row.document instanceof File) {
                const apiKey = fileKeyMap[row.key] || row.key;
                formData.append(apiKey, row.document, row.document.name);
            }

            // Handle nested files (e.g. passbook inside Bank Details)
            if (row.value && typeof row.value === "object") {
                Object.entries(row.value).forEach(([key, val]) => {
                    if (val instanceof File) {
                        const apiKey = fileKeyMap[key] || key;
                        formData.append(apiKey, val, val.name);
                    }
                });
            }
        });

        // 🔍 Debug — check exactly what's sent
        for (let [key, val] of formData.entries()) {
            console.log("🧾 FormData entry:", key, val);
        }

        try {
            const response = await fetch(
                `https://backend.maamaas.com/food/api/super-admin-profile/edit/${currentVendorId}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: formData,
                }
            );

            if (!response.ok) {
                const errorText = await response.text();
                console.error("❌ Update failed:", errorText);
                alert("❌ Update failed. Check console for details.");
                return;
            }

            const result = await response.json();
            console.log("✅ Updated data:", result);
            alert("✅ Updated successfully!");

            // Refresh UI
            setVendorDetails(result);
            mapAndSetRowsFromVendorDetails(result);
        } catch (error) {
            console.error("❌ Update error:", error);
            alert("Error updating data. Check console for details.");
        }
    };

    const handleUploadClick = (index) => fileInputRefs.current[index]?.click();
    const getValue = (key) => rows.find((r) => r.key === key)?.value;



    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("authToken");
        if (!token) return alert("Token missing. Please log in again.");

        setLoading(true);

        try {
            const addressValue = getValue("Address");
            const bankDetailsValue = getValue("Bank Details");

            const parsedPincode = addressValue?.pincode ? parseInt(addressValue.pincode, 10) : null;

            const profileData = {
                id: 0,
                ownerName: getValue("Admin Name") || null,
                companyName: getValue("Company Name") || null,
                phoneNumber: getValue("Phone No") || null,
                email: getValue("Email ID") || null,
                panNumber: getValue("PAN CARD NO") || null,
                aadharNumber: getValue("AADHAR CARD NO") || null,
                doorNumber: addressValue?.doorNo || null,
                addressLine: addressValue?.street || null,
                city: addressValue?.city || null,
                state: addressValue?.state || null,
                stateCode: addressValue?.stateCode || null,
                district: addressValue?.district || null,
                pincode: parsedPincode,
                landMark: addressValue?.landmark || null,
                location: addressValue?.location || null,
                gstNumber: getValue("GST No.") || null,
                tradeStartDate: getValue("Trade License")?.startDate || null,
                tradeEndDate: getValue("Trade License")?.endDate || null,
                holderName: bankDetailsValue?.holderName || null,
                accountNumber: bankDetailsValue?.accountNumber || null,
                branchName: bankDetailsValue?.branchName || null,
                bankName: bankDetailsValue?.bankName || null,
                ifscCode: bankDetailsValue?.ifscCode || null,
                adminUserId: 0,
            };

            const formData = new FormData();
            formData.append("profileData", new Blob([JSON.stringify(profileData)], { type: "application/json" }));

            const fileFields = [
                { rowKey: "PAN CARD NO", formKey: "panImage" },
                { rowKey: "AADHAR CARD NO", formKey: "aadharImage" },
                { rowKey: "Trade License", formKey: "tradeLicenseDocument" }, // ✅ This is correct
                { rowKey: "Admin Name", formKey: "adminImage" }, // ✅ Correct key // Changed from "Admin Image" to "Admin Name"
            ];

            for (const { rowKey, formKey } of fileFields) {
                const file = getDocumentFile(rowKey); // function to get the selected file
                if (file) formData.append(formKey, file);
            }

            const apiUrl = `https://backend.maamaas.com/food/api/super-admin-profile/add/1`;
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`, // do NOT set Content-Type
                },
                body: formData,
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("API returned error:", errorText);
                alert("Error submitting data. Check console.");
                return;
            }

            const result = await response.json();
            console.log("API response:", result);

            if (result.vendorId) {
                localStorage.setItem("vendorId", result.vendorId);
                setCurrentVendorId(result.vendorId);
                alert("Submitted successfully!");
                // await getVendorDetails(result.vendorId);
            }

        } catch (err) {
            console.error("Submission error:", err);
            alert("Error submitting data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid"><div className="row">
            <div className="col-lg-10">
                <div className="scrooltable" style={{ marginTop: "-50px", padding: "0px", overflow: "auto", height: '580px' }}>
                    <form onSubmit={handleSubmit}>
                        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "60px" }}>
                            <thead>
                                <tr>
                                    <th style={tableHeaderStyle}>Field</th>
                                    <th style={tableHeaderStyle}>Value</th>
                                    <th style={tableHeaderStyle}>Document</th>
                                    {/* <th style={tableHeaderStyle}>Status</th> */}
                                    <th style={tableHeaderStyle}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={row.key} style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                                        <td style={tableCellStyle}>{row.key}</td>
                                        <td style={tableCellStyle}> {/* Value Column */}
                                            {row.isEditing && row.key !== "Remarks" ? (
                                                row.key.includes("License") ? (
                                                    (row.value?.startDate !== undefined || row.value?.endDate !== undefined) ? (
                                                        <>
                                                            <div>
                                                                <input type="date" value={row.value.startDate || ""}
                                                                    onChange={(e) => setRows(prevRows => prevRows.map((r, i) => i === index ? { ...r, value: { ...r.value, startDate: e.target.value } } : r))}
                                                                    style={{ border: '1px solid #ccc', padding: '5px', width: 'calc(100% - 12px)', marginBottom: '5px' }}
                                                                    placeholder="Start Date"
                                                                />
                                                            </div>
                                                            <div>
                                                                <input type="date" value={row.value.endDate || ""}
                                                                    onChange={(e) => setRows(prevRows => prevRows.map((r, i) => i === index ? { ...r, value: { ...r.value, endDate: e.target.value } } : r))}
                                                                    style={{ border: '1px solid #ccc', padding: '5px', width: 'calc(100% - 12px)' }}
                                                                    placeholder="End Date"
                                                                />
                                                            </div>
                                                        </>
                                                    ) : "Invalid license data structure"
                                                )
                                                    : row.isDropdown ? (
                                                        <select value={row.value || ""} onChange={(e) => setRows(prevRows => prevRows.map((r, i) => i === index ? { ...r, value: e.target.value } : r))} style={{ width: "100%", border: '1px solid #ccc', padding: '5px' }}>
                                                            <option value="">-- Select --</option> {row.options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                                        </select>
                                                    ) : row.key === "Address" || row.key === "Bank Details" ? (
                                                        (typeof row.value === 'object' && row.value !== null) ? (
                                                            Object.entries(row.value).map(([k, v_val]) => {
                                                                if (k === 'passbookFile' || k === 'passbookServerFileName') return null;
                                                                return (
                                                                    <div key={k} style={{ marginBottom: '5px' }}>
                                                                        <input type={k === 'pincode' || k === 'accountNumber' ? 'text' : 'text'}
                                                                            value={v_val || ""}
                                                                            onChange={(e) => setRows(prevRows => prevRows.map((r, rowIndex) => {
                                                                                if (rowIndex === index) { const currentVal = (typeof r.value === 'object' && r.value !== null) ? r.value : getRowConfigForKey(row.key).value; return { ...r, value: { ...currentVal, [k]: e.target.value } }; }
                                                                                return r;
                                                                            }))}
                                                                            style={{ border: '1px solid #ccc', padding: '5px', width: 'calc(100% - 12px)' }}
                                                                            placeholder={k.replace(/([A-Z])/g, ' $1').trim().replace(/^\w/, c => c.toUpperCase())}
                                                                        />
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (<input type="text" value="Invalid data structure" disabled />)
                                                    ) : (
                                                        <input type={row.key === "Phone No" ? "tel" : "text"} value={row.value || ""} onChange={(e) => setRows(prevRows => prevRows.map((r, i) => i === index ? { ...r, value: e.target.value } : r))} style={{ width: "100%", border: '1px solid #ccc', padding: '5px' }} placeholder={`Enter ${row.key}`} />
                                                    )
                                            ) : (
                                                row.key === "Address" || row.key === "Bank Details" ? (
                                                    (typeof row.value === 'object' && row.value !== null && Object.values(row.value).some(val => (typeof val === 'string' && val.trim() !== '') || (typeof val === 'object' && val !== null))) ? (
                                                        Object.entries(row.value).map(([k, v_val]) => {
                                                            if (k === 'passbookFile' || k === 'passbookServerFileName') return null;
                                                            if (v_val && (typeof v_val === 'string' || typeof v_val === 'number')) {
                                                                return <div key={k}><strong style={{ textTransform: 'capitalize' }}>{k.replace(/([A-Z])/g, ' $1').trim()}:</strong> {String(v_val)}</div>;
                                                            } return null;
                                                        })
                                                    ) : (<em>Not specified</em>)
                                                ) : row.key.includes("License") ? ((row.value?.startDate || row.value?.endDate) ? (<><strong>Start:</strong> {row.value.startDate || "N/A"}, <strong>End:</strong> {row.value.endDate || "N/A"}</>) : (<em>Not specified</em>))
                                                    : (row.value || <em>Not specified</em>)
                                            )}
                                        </td>
                                        <td style={tableCellStyle}>
                                            {row.isUpload ? (
                                                <>
                                                    <button
                                                        type="button"
                                                        style={buttonStyle}
                                                        onClick={() => handleUploadClick(index)}
                                                    >
                                                        {row.document
                                                            ? row.document instanceof File
                                                                ? "Change File"
                                                                : "Update File"
                                                            : "Upload File"}
                                                    </button>

                                                    <input
                                                        type="file"
                                                        style={{ display: "none" }}
                                                        ref={(el) => (fileInputRefs.current[index] = el)}
                                                        onChange={(e) => handleFileChange(e, index)}
                                                        accept="image/*,.pdf,.doc,.docx"
                                                    />

                                                    <div
                                                        style={{
                                                            marginTop: "5px",
                                                            fontSize: "0.9em",
                                                            wordBreak: "break-all",
                                                        }}
                                                    >
                                                        {row.document instanceof File ? (
                                                            row.document.type.startsWith("image/") ? (
                                                                <img
                                                                    src={URL.createObjectURL(row.document)}
                                                                    alt="Selected"
                                                                    style={{ width: "80px", height: "80px", borderRadius: "8px" }}
                                                                />
                                                            ) : (
                                                                <span>{row.document.name}</span>
                                                            )
                                                        ) : row.document && row.document.url ? (
                                                            row.document.url.endsWith(".pdf") || row.document.url.match(/\.(doc|docx)$/) ? (
                                                                <span>{row.document.name || "Document"}</span>
                                                            ) : (
                                                                <img
                                                                    src={row.document.url}
                                                                    alt="Server File"
                                                                    style={{ width: "80px", height: "80px", borderRadius: "8px" }}
                                                                />
                                                            )
                                                        ) : (
                                                            <em>No file selected</em>
                                                        )}
                                                    </div>
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </td>


                                        {/* <td style={tableCellStyle}> 
                                             <span style={{ color: ["Verified", "Uploaded", "Submitted", "Provided"].includes(row.status) ? "green" : (["Invalid", "Error", "Rejected", "Not Uploaded", "Not Verified", "Pending"].includes(row.status) ? "orange" : "grey") }}> {row.status} </span>
                                         </td> */}
                                        <td style={tableCellStyle}> {/* Actions Column */}
                                            {row.key === "Remarks" ? (
                                                <span>-</span>
                                            ) : row.isEditing ? (
                                                <button type="button" style={saveButtonStyle} onClick={() => handleSave(index)}>Save</button>
                                            ) : (
                                                <button type="button" style={editButtonStyle} onClick={() => handleEdit(index)}>Edit</button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {/* Conditionally show Submit or Update button */}





                        {/* <button type="submit" style={{ ...submitAllButtonStyle, opacity: loading ? 0.7 : 1 }} disabled={loading}> {loading ? (currentVendorId ? "Updating..." : "Submitting...") : (currentVendorId ? "Update All Details" : "Submit & Next")} </button> */}


                    </form>
                    {!currentVendorId ? (
                        <button
                            type="submit"
                            style={submitAllButtonStyle}
                            disabled={loading}
                            onClick={handleSubmit}
                        >
                            {loading ? "Submitting..." : "Submit & Next"}
                        </button>
                    ) : (
                        <button
                            type="button"
                            style={submitAllButtonStyle}
                            disabled={loading}
                            onClick={handleUpdateAll}
                        >
                            {loading ? "Updating..." : "Update Details"}
                        </button>
                    )}

                    {loading && <div style={{ marginTop: '10px', textAlign: 'center', fontWeight: 'bold' }}>Processing...</div>}
                </div>
            </div>

        </div></div>
    );
};

const tableHeaderStyle = { border: "1px solid #ccc", padding: "10px", backgroundColor: "#b15cd6", color: "white", textAlign: "center" };
const tableCellStyle = { border: "1px solid #ccc", padding: "10px", verticalAlign: "top", textAlign: "left" };
const evenRowStyle = { backgroundColor: "#f9f9f9" };
const oddRowStyle = { backgroundColor: "#ffffff" };
const buttonStyle = { backgroundColor: "#5bc0de", color: "white", padding: "6px 12px", border: "none", borderRadius: "4px", cursor: "pointer", marginRight: "5px", marginBottom: '5px' };
const editButtonStyle = { ...buttonStyle, backgroundColor: "#f0ad4e" };
const saveButtonStyle = { ...buttonStyle, backgroundColor: "#5cb85c" };
const submitAllButtonStyle = { backgroundColor: "#008CBA", color: "white", padding: "10px 20px", border: "none", borderRadius: "5px", cursor: "pointer", marginTop: "20px" };

export default Registration;
